NIRV.appSettings = function () {
  NIRV.highlight_tasks(false);

  var checked_pref = function (key, value) {
    return NIRV.prefs[key] != undefined && NIRV.prefs[key].value == value
      ? 'checked'
      : '';
  };
  var selected_pref = function (key, value) {
    return NIRV.prefs[key] != undefined && NIRV.prefs[key].value == value
      ? 'selected'
      : '';
  };

  var html = '';

  html +=
    '<div style="position: absolute; bottom: 0; left: 3rem; font-size: 10px; opacity: 0.4;">';
  html += 'Nirvana v.' + NIRV.version;
  html += '</div>';

  html +=
    '<form action="#" method="post" id="preferences" onSubmit="return false;">';
  html += '    <fieldset>';
  html += '        <table width="100%">';
  html += '            <tr valign="top">';
  html += '                <td width="33%">';

  html += '                    <div class="section">';
  html +=
    '                        <h3>' +
    NIRV.L.settings_global_area_filtering +
    '</h3>';
  html += '                        <div class="caption">';
  html +=
    '                            ' +
    NIRV.L.settings_global_area_filtering_caption;
  html += '                        </div>';
  html +=
    '                        <input type="radio" name="UIAreaFiltering" value="exclusive" id="UIAreaFiltering-exclusive" ' +
    checked_pref('UIAreaFiltering', 'exclusive') +
    ' /> <label for="UIAreaFiltering-exclusive">' +
    NIRV.L.settings_hidden +
    '</label> &nbsp;&nbsp;';
  html +=
    '                        <input type="radio" name="UIAreaFiltering" value="inclusive" id="UIAreaFiltering-inclusive" ' +
    checked_pref('UIAreaFiltering', 'inclusive') +
    ' /> <label for="UIAreaFiltering-inclusive">' +
    NIRV.L.settings_still_visible +
    '</label> &nbsp;&nbsp; ';
  html += '                        <br />';
  html += '                    </div>';

  html += '                    <div class="section">';
  html +=
    '                        <h3>' + NIRV.L.settings_task_counts + '</h3>';
  html += '                        <div class="caption">';
  html += '                            ' + NIRV.L.settings_task_counts_caption;
  html += '                        </div>';
  html +=
    '                        <input type="radio" name="UICounts" value="" id="UICounts-default" ' +
    checked_pref('UICounts', '') +
    ' /> <label for="UICounts-default">' +
    NIRV.L.settings_default +
    '</label> &nbsp;&nbsp;';
  html +=
    '                        <input type="radio" name="UICounts" value="all" id="UICounts-all" ' +
    checked_pref('UICounts', 'all') +
    ' /> <label for="UICounts-all">' +
    NIRV.L.settings_show_all +
    '</label> &nbsp;&nbsp; ';
  html += '                        <br />';
  html += '                    </div>';

  html += '                    <div class="section">';
  html += '                        <h3>' + NIRV.L.settings_projects + '</h3>';
  html += '                        <div class="caption">';
  html += '                            ' + NIRV.L.settings_projects_caption;
  html += '                        </div>';
  html +=
    '                        <input type="radio" name="UIDefaultProjectType" value="0" id="UIDefaultProjectType-parallel" ' +
    checked_pref('UIDefaultProjectType', '0') +
    ' /> <label for="UIDefaultProjectType-parallel">' +
    NIRV.L.settings_parallel +
    '</label> &nbsp;&nbsp;';
  html +=
    '                        <input type="radio" name="UIDefaultProjectType" value="1" id="UIDefaultProjectType-sequential" ' +
    checked_pref('UIDefaultProjectType', '1') +
    ' /> <label for="UIDefaultProjectType-sequential">' +
    NIRV.L.settings_sequential +
    '</label> &nbsp;&nbsp; ';
  html += '                        <br />';
  html += '                    </div>';

  html += '                    <div class="section">';
  html += '                        <h3>' + NIRV.L.settings_later + '</h3>';
  html += '                        <div class="caption">';
  html += '                            ' + NIRV.L.settings_later_caption;
  html += '                        </div>';
  html +=
    '                        <input type="radio" name="UIEnableLater" value="0" id="UIEnableLater-no" ' +
    checked_pref('UIEnableLater', '0') +
    ' /> <label for="UIEnableLate-no">' +
    NIRV.L.settings_off +
    '</label> &nbsp;&nbsp;';
  html +=
    '                        <input type="radio" name="UIEnableLater" value="1" id="UIEnableLater-yes" ' +
    checked_pref('UIEnableLater', '1') +
    ' /> <label for="UIEnableLater-yes">' +
    NIRV.L.settings_on +
    '</label> &nbsp;&nbsp; ';
  html += '                        <br />';
  html += '                    </div>';

  html += '                </td>';
  html += '                <td width="33%">';

  html += '                    <div class="section">';
  html +=
    '                        <h3>' + NIRV.L.settings_inbox_and_areas + '</h3>';
  html += '                        <div class="caption">';
  html +=
    '                            ' + NIRV.L.settings_inbox_and_areas_caption;
  html += '                        </div>';
  html +=
    '                        <input type="radio" name="UIAreaAssignment" value="0" id="UIAreaAssignment-no" ' +
    checked_pref('UIAreaAssignment', '0') +
    ' /> <label for="UIAreaAssignment-no">' +
    NIRV.L.settings_move_tasks_without_assignment +
    '</label>';
  html += '                        <div style="height:5px;"></div>';
  html +=
    '                        <input type="radio" name="UIAreaAssignment" value="1" id="UIAreaAssignment-yes" ' +
    checked_pref('UIAreaAssignment', '1') +
    ' /> <label for="UIAreaAssignment-yes">' +
    NIRV.L.settings_assign_tasks_to_current_area +
    '</label>';
  html += '                        <br />';
  html += '                    </div>';

  html += '                    <div class="section">';
  html +=
    '                        <h3>' + NIRV.L.settings_rapid_entry + '</h3>';
  html += '                        <div class="caption">';
  html += '                            ' + NIRV.L.settings_rapid_entry_caption;
  html += '                        </div>';
  html +=
    '                        <input type="radio" name="UIEnableRapidEntry" value="" id="UIEnableRapidEntry-no" ' +
    checked_pref('UIEnableRapidEntry', '0') +
    ' /> <label for="UIEnableRapidEntry-no">' +
    NIRV.L.settings_hide +
    '</label> &nbsp;&nbsp;';
  html +=
    '                        <input type="radio" name="UIEnableRapidEntry" value="hide" id="UIEnableRapidEntry-yes" ' +
    checked_pref('UIEnableRapidEntry', '1') +
    ' /> <label for="UIEnableRapidEntry-yes">' +
    NIRV.L.settings_show +
    '</label> ';
  html += '                        <br />';
  html += '                    </div>';

  html += '                    <div class="section">';
  html += '                        <h3>' + NIRV.L.settings_logbook + '</h3>';
  html += '                        <div class="caption">';
  html += '                            ' + NIRV.L.settings_logbook_caption;
  html += '                        </div>';
  html +=
    '                        <select name="UICollectCompleted" id="UICollectCompleted">';
  html +=
    '                           <optgroup label="' +
    NIRV.L.settings_log_items +
    '">';
  html +=
    '                               <option value="immediately" ' +
    selected_pref('UICollectCompleted', 'immediately') +
    '>' +
    NIRV.L.settings_immediately +
    '</option>';
  html +=
    '                               <option value="daily" ' +
    selected_pref('UICollectCompleted', 'daily') +
    '>' +
    NIRV.L.settings_daily +
    '</option>';
  html +=
    '                               <option value="manually" ' +
    selected_pref('UICollectCompleted', 'manually') +
    '>' +
    NIRV.L.settings_manually +
    '</option>';
  html += '                           </optgroup>';
  html += '                        </select><br />';
  html += '                    </div>';

  html +=
    '                    <div class="section" rel="UIBLeaveCompletedInPlace">';
  html += '                        <h3>' + NIRV.L.settings_completed + '</h3>';
  html += '                        <div class="caption">';
  html += '                            ' + NIRV.L.settings_completed_caption;
  html += '                        </div>';
  html +=
    '                        <input type="radio" name="UIBLeaveCompletedInPlace" value="0" id="UIBLeaveCompletedInPlace-no" ' +
    checked_pref('UIBLeaveCompletedInPlace', '0') +
    ' /> <label for="UIBLeaveCompletedInPlace-no">' +
    NIRV.L.settings_no +
    '</label> &nbsp;&nbsp;';
  html +=
    '                        <input type="radio" name="UIBLeaveCompletedInPlace" value="1" id="UIBLeaveCompletedInPlace-yes" ' +
    checked_pref('UIBLeaveCompletedInPlace', '1') +
    ' /> <label for="UIBLeaveCompletedInPlace-yes">' +
    NIRV.L.settings_yes +
    '</label> &nbsp;&nbsp;';
  html += '                        <br />';
  html += '                    </div>';

  html += '                </td>';
  html += '                <td width="*">';

  html += '<div class="section">';
  html += '<h3>' + NIRV.L.settings_look_and_feel + '</h3>';
  html += '<div class="caption">';
  html += NIRV.L.settings_look_and_feel_caption;
  html += '</div>';

  html += '<ul style="margin: .5rem 0;">';
  NIRV.themes.forEach((theme) => {
    html += `<li class="theme-chip fn" style="background-color: ${theme.backgroundColor}; border: 1px solid #797979; border-radius: 1rem; width: 1rem; height: 1rem; display: inline-block; margin: 0 5px 3px 0; box-shadow: 0 0 1px rgba(0,0,0,0);" fn="NIRV.setPref" p1="UITheme" p2='${theme.name}' p3="true"  />`;
  });
  html += '</ul>';

  html += '<select name="UIBAppearance" id="UIBAppearance">';
  html += '<optgroup label="' + NIRV.L.settings_appearance + '">';
  html += '<option value="light" ';
  html +=
    selected_pref('UIBAppearance', 'light') +
    '>' +
    NIRV.L.settings_light +
    '</option>';
  html += '<option value="dark" ';
  html +=
    selected_pref('UIBAppearance', 'dark') +
    '>' +
    NIRV.L.settings_dark +
    '</option>';
  html += '<option disabled>───────</option>';
  html += '<option value="auto" ';
  html +=
    selected_pref('UIBAppearance', 'auto') +
    '>' +
    NIRV.L.settings_sync_with_os +
    '</option>';
  html += '</optgroup>';
  html += '</select>';

  html += '<span class="hide-darkmode hide-2025" style="white-space: nowrap">';
  html += '<select name="UIBThemeBackground" id="UIBThemeBackground">';
  html += '<optgroup label="' + NIRV.L.settings_background + '">';
  html += '<option value="light" ';
  html +=
    selected_pref('UIBThemeBackground', 'light') +
    '>' +
    NIRV.L.settings_snow +
    '</option>';
  html += '<option value="dark" ';
  html +=
    selected_pref('UIBThemeBackground', 'dark') +
    '>' +
    NIRV.L.settings_slate +
    '</option>';
  html += '</optgroup>';
  html += '</select>';
  html += '</span>';

  html += '<div style="white-space: nowrap">';
  html += '<select name="UIBDensity" id="UIBDensity">';
  html += '<optgroup label="' + NIRV.L.settings_density + '">';
  html += '<option value="compact" ';
  html +=
    selected_pref('UIBDensity', 'compact') +
    '>' +
    NIRV.L.settings_compact +
    '</option>';
  html += '<option value="comfortable" ';
  html +=
    selected_pref('UIBDensity', 'comfortable') +
    '>' +
    NIRV.L.settings_comfortable +
    '</option>';
  html += '</optgroup>';
  html += '</select>';
  html += '</div>';

  html += '<div style="white-space: nowrap">';
  html += '<select name="UILanguage" id="UILanguage">';
  html += '<optgroup label="' + NIRV.L.settings_language + '">';
  html += '<option value="en" ';
  html +=
    selected_pref('UILanguage', 'en') +
    '>' +
    NIRV.L.settings_english +
    '</option>';
  html += '<option value="es" ';
  html +=
    selected_pref('UILanguage', 'es') +
    '>' +
    NIRV.L.settings_espanol +
    '</option>';
  // html += '<option value="fr" ';
  // html +=
  //   selected_pref('UILanguage', 'fr') +
  //   '>' +
  //   NIRV.L.settings_francais +
  //   '</option>';
  // html += '<option value="ja" ';
  // html +=
  //   selected_pref('UILanguage', 'ja') +
  //   '>' +
  //   NIRV.L.settings_japanese +
  //   '</option>';
  html += '</optgroup>';
  html += '</select>';
  html += '</div>';

  html += '</div>';

  html += '                    <div class="section">';
  html +=
    '                        <h3>' + NIRV.L.settings_date_format + '</h3>';
  html += '                        <div class="caption">';
  html += '                            ' + NIRV.L.settings_date_format_caption;
  html += '                        </div>';
  html +=
    '                        <select name="UIDateLocale" id="UIDateLocale">';
  html +=
    '                           <optgroup label="' +
    NIRV.L.settings_date_format +
    '">';
  html +=
    '<option value="en-US" ' +
    selected_pref('UIDateLocale', 'en-US') +
    '>' +
    ymdtolocale(datetoymd(new Date()), 'MMMDY', 'en-US') +
    ' (US)</option>';
  html +=
    '<option value="en-GB" ' +
    selected_pref('UIDateLocale', 'en-GB') +
    '>' +
    ymdtolocale(datetoymd(new Date()), 'MMMDY', 'en-GB') +
    ' (UK)</option>';
  // html +=
  //   '<option value="de-DE" ' +
  //   selected_pref('UIDateLocale', 'de-DE') +
  //   '>' +
  //   ymdtolocale(datetoymd(new Date()), 'MMMDY', 'de-DE') +
  //   ' (DE)</option>';
  html +=
    '<option value="fr-FR" ' +
    selected_pref('UIDateLocale', 'fr-FR') +
    '>' +
    ymdtolocale(datetoymd(new Date()), 'MMMDY', 'fr-FR') +
    ' (FR)</option>';
  html +=
    '<option value="es-ES" ' +
    selected_pref('UIDateLocale', 'es-ES') +
    '>' +
    ymdtolocale(datetoymd(new Date()), 'MMMDY', 'es-ES') +
    ' (ES)</option>';
  html +=
    '<option value="ja-JP" ' +
    selected_pref('UIDateLocale', 'ja-JP') +
    '>' +
    ymdtolocale(datetoymd(new Date()), 'MMMDY', 'ja-JP') +
    ' (JP)</option>';
  html += '                           </optgroup>';
  html += '                        </select>';
  html += '                        <br />';
  html += '                    </div>';

  html += '                    <div class="section">';
  html +=
    '                        <h3>' + NIRV.L.settings_calendar_week + '</h3>';
  html += '                        <div class="caption">';
  html +=
    '                            ' + NIRV.L.settings_calendar_week_caption;
  html += '                        </div>';
  html +=
    '                        <input type="radio" name="UIDateWeekStartsOn" value="0" id="UIDateWeekStartsOnSun" ' +
    checked_pref('UIDateWeekStartsOn', '0') +
    ' /> <label for="UIDateWeekStartsOnSun">' +
    NIRV.L.settings_sunday +
    '</label> &nbsp;&nbsp; ';
  html +=
    '                        <input type="radio" name="UIDateWeekStartsOn" value="1" id="UIDateWeekStartsOnMon" ' +
    checked_pref('UIDateWeekStartsOn', '1') +
    ' /> <label for="UIDateWeekStartsOnMon">' +
    NIRV.L.settings_monday +
    '</label> &nbsp;&nbsp;';
  html += '                        <br />';
  html += '                    </div>';

  html += '                    <div class="section">';
  html += '                        <h3>' + NIRV.L.settings_due_dates + '</h3>';
  html += '                        <div class="caption">';
  html += '                            ' + NIRV.L.settings_due_dates_caption;
  html += '                        </div>';
  html +=
    '                        <input type="radio" name="UIRelativeDueDates" value="hide" id="UIRelativeDueDates-enable" ' +
    checked_pref('UIRelativeDueDates', '1') +
    ' /> <label for="UIRelativeDueDates-enable">' +
    NIRV.L.settings_due_in_2_days +
    '</label> &nbsp;&nbsp; ';
  html +=
    '                        <input type="radio" name="UIRelativeDueDates" value="" id="UIRelativeDueDates-disable" ' +
    checked_pref('UIRelativeDueDates', '0') +
    ' /> <label for="UIRelativeDueDates-disable">' +
    ymdtomd(datetoymd(new Date().addDays(2))) +
    '</label> &nbsp;&nbsp;';
  html += '                        <br />';
  html += '                    </div>';

  // html += '                    <div class="section">';
  // html += '                        <h3>Account Settings</h3>';
  // html += '                        <div class="caption">To change your email preferences, name or password, to upgrade or delete your account, or to export your account data, <a class="sso-account" href="'+NIRV.baseurl_acc+'" target="_blank" rel="external">click here</a>.<br><br></div>';
  // html += '                    </div>';

  html += '                </td>';
  html += '            </tr>';
  html += '        </table>';
  html += '    </fieldset>';
  html += '</form>';

  var options = {
    autoOpen: false,
    dialogClass: 'preferences',
    title: NIRV.L.preferences, // + NIRV.user.emailaddress,
    height: 'auto',
    width: 900,
    modal: true,
    resizable: false,
    buttons: {
      [NIRV.L.done]: function () {
        $(this).dialog('close');
      },
    },
  };
  // $('#dialog').dialog('destroy');
  $('#dialog').html(html);
  $('#dialog').dialog(options);
  $('#dialog').dialog('open');
};
